import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PROMOS_QUERY_KEY} from "../queryKeys";
import {ReachPromo} from "./types";

type Variables = {count_accounts?: boolean};

const getPromos = async (variables: Variables): Promise<ReachPromo[]> => {
  const response = await axiosReachInstance.get<ReachPromo[], AxiosResponse<ReachPromo[]>>("/promos", {
    params: {count_accounts: variables.count_accounts ?? false},
  });
  return response.data;
};

export const useGetPromos = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachPromo[], Variables>
): BaseUseQueryResult<ReachPromo[]> => {
  return useBaseQuery<ReachPromo[], Variables>(
    [PROMOS_QUERY_KEY, variables.count_accounts ?? false],
    getPromos,
    variables,
    options
  );
};
